export default __webpack_public_path__ + "static/media/bg-pattern-light.76f84bb3.svg";